import { GlCollapsibleListbox, GlLink } from '@gitlab/ui';
import { __ } from '~/locale';
import { setCookie } from '~/lib/utils/common_utils';
import { helpPagePath } from '~/helpers/help_page_helper';
import { PREFERRED_LANGUAGE_COOKIE_KEY, EN } from '../constants';
const HELP_TRANSLATE_MSG = __('Help translate to your language');
const HELP_TRANSLATE_HREF = helpPagePath('/development/i18n/translation.md');
export default {
    name: 'LanguageSwitcherApp',
    components: {
        GlCollapsibleListbox,
        GlLink
    },
    inject: {
        locales: {
            default: []
        },
        preferredLocale: {
            default: EN
        }
    },
    data () {
        return {
            selected: this.preferredLocale.value
        };
    },
    methods: {
        onLanguageSelected (code) {
            setCookie(PREFERRED_LANGUAGE_COOKIE_KEY, code);
            window.location.reload();
        },
        itemTestSelector (locale) {
            return `language_switcher_lang_${locale}`;
        },
        itemLangAttribute (locale) {
            return locale.replace(/_/g, '-');
        }
    },
    HELP_TRANSLATE_MSG,
    HELP_TRANSLATE_HREF
};
